import React from 'react';
import PropTypes from 'prop-types';
import UserService from '../../../services/user.service';

const NewMessageToast = ({ t, displayMessage, username, userAvatar }) =>
  (<a
    style={{
      display: 'flex',
    }}
    className="view-msg"
    onClick={e => displayMessage(e)}
  >
    <img
      style={{
        width: '40px',
        borderRadius: '100%',
        marginRight: '8px',
      }}
      src={userAvatar}
      className="preview4 img-responsive"
      alt=""
      onError={(e) => { e.target.src = UserService.defaultAvatar; }}
    />
    {`${t('New message from')} ${username}`}
   </a>);

NewMessageToast.propTypes = {
  t: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  userAvatar: PropTypes.string.isRequired,
  displayMessage: PropTypes.func.isRequired,
};

export default NewMessageToast;



// WEBPACK FOOTER //
// ./src/components/modules/newMessageToast/NewMessageToast.jsx